import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
  selectPrefix,
  selectTableMasterPrefix,
} from '../utility/Redux/profile';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';

import axios from 'axios';
import { FormatNumber2 } from '../utility/component/tools';
import { CollectionFromToDate } from '../utility/component/collectionFromToDate';
import RemoveIcon from '@mui/icons-material/Remove';
import {
  selectCustomerMasterHelpModStatus,
  setAlertWithTitle,
  setCustomerMasterHelpModStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import {
  selectBookingCustomerDetails,
  setBookingAttachImage,
  setBookingCustomerDetails,
  setHistoryOrderDetails,
  setModifyingBookingId,
  setSelctedBookingUpperitemDetails,
  setSelectedBooingLowerItemDetails,
} from '../utility/Redux/booking';
import { setViewBillInvoiceId, setViewBillMod } from '../utility/Redux/billing';
import AddIcon from '@mui/icons-material/Add';
import { CollectionFromToDateMobile } from '../utility/component/collectionFromToDateMobile';
import { useNavigate } from 'react-router-dom';
import PrintOrderSummary from './printOrderSummary';
import { useReactToPrint } from 'react-to-print';
import CustomerMasterhelp from '../help/customermasterHelp';
import { getEmptyMeasurementList } from '../utility/func/common';
import MeasurmentSlip from '../masters/measurmentSlip';
import AlertModalTwoButton from '../utility/component/modals/alertWithTwoButton';
import QrCodeSlip from '../masters/qrSlip';
import FilterData from './filterData';
import OrderWiseQrCode from '../masters/orderQrSlip';
import { CallAPIPromise } from '../utility/func/func';
const width = window.innerWidth / 100;

const OrderSummary = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const [firstDate, setFirstDate] = useState(moment().format('YYYY-MM-DD'));
  const [SecondDate, setSecondDate] = useState(moment().format('YYYY-MM-DD'));
  const [lowerList, setLowerList] = useState([]);
  const [upperList, setUpperList] = useState([]);
  const [selectedQrList, setSelectedQrList] = useState([]);
  const [lowerListQR, setLowerListQR] = useState([]);
  const [upperListQR, setUpperListQR] = useState([]);
  const [list, setList] = useState([]);
  const [FullList, setFullList] = useState([]);
  const [filterQrSearchTExt, setFlterQrSearchText] = useState('');
  const [bookingOrderNumber, setBookingOrderNumber] = useState('');
  const bookingCustomerDetails = useSelector(selectBookingCustomerDetails);
  const slipRef = useRef();
  const [selectedQrValue, setSelectedQrValue] = useState('');
  const QrprintRef = useRef();
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState({
    title: '',
    msg: '',
    status: false,
    setStatus: '',
    button1: '',
    button1Click: '',
    button2: '',
    button2Click: '',
  });
  const [isUpper, setIsUpper] = useState([]);
  const [isLower, setIsLower] = useState([]);
  const [qrType, setIsQrType] = useState('');
  const customerMasterModalStatus = useSelector(
    selectCustomerMasterHelpModStatus
  );
  const [bookingDetails, setBookingDetails] = useState({
    bookingOrderNumber: '',
    upperTryDate: '',
    upperDeliveryDate: '',
    lowerTryDate: '',
    lowerDeleveryDate: '',
    remarks: {
      lower: '',
      upper: '',
    },
    selectedUpperItemDetails: '',
    selectedLowerItemDetails: '',
    mobile: '',
    customer_name: '',
    date: moment().format('YYYY-MM-DD'),
  });

  const customerDetails = (params) => {
    dispatch(setBookingCustomerDetails(''));
    dispatch(setBookingAttachImage(''));
    dispatch(setSelectedBooingLowerItemDetails(''));
    dispatch(setSelctedBookingUpperitemDetails(''));
    dispatch(setModifyingBookingId(''));
    dispatch(setBookingCustomerDetails(params.row));
    dispatch(setCustomerMasterHelpModStatus(false));
    dispatch(setHistoryOrderDetails(''));
  };

  const columns = [
    {
      field: 'DATE',
      type: 'number',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      accessor: 'DATE',
      renderCell: (param) => {
        return <div>{moment(param.value).format('YYYY-MM-DD')}</div>;
      },
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      field: 'PREFIX',
      accessor: 'PREFIX',
      type: 'number',
      width: 80,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Prefix'}
        </div>
      ),
    },
    {
      field: 'MRC_NO',
      accessor: 'MRC_NO',
      type: 'number',
      width: 100,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'MRC No.'}
        </div>
      ),
    },
    {
      field: 'BOOKING_ORDER_NO',
      accessor: 'BOOKING_ORDER_NO',
      type: 'number',
      width: 130,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Booking Order'}
        </div>
      ),
    },
    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: 132,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },
    {
      accessor: 'CUSTOMER_NAME',
      field: 'CUSTOMER_NAME',
      type: 'string',
      flex: 1,
      minWidth: 240,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Customer Name'}
        </div>
      ),
    },
    {
      accessor: 'COUNTRY',
      field: 'COUNTRY',
      type: 'string',
      width: 160,
      headerAlign: 'center',
      align: 'left',

      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Country'}
        </div>
      ),
    },

    {
      field: 'CITY',
      accessor: 'CITY',
      type: 'string',
      width: 160,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'City'}
        </div>
      ),
    },
    {
      field: 'ORDER_ACTIONS',
      headerName: 'Action',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => (
        <button
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            setSelectedQrList([]);
            setFlterQrSearchText('');
            setSelectedQrValue('');
            setBookingOrderNumber(params.row.BOOKING_ORDER_NO);
            getOrderDetails(params.row.BOOKING_ORDER_NO, false, true);
          }}
          className="rounded-md border border-[#f5874f] bg-[#fff2eb] px-2.5 py-1 text-[11px] font-semibold text-[#dc6f39] transition hover:bg-[#f5874f] hover:text-white"
          aria-label={`Open print options for order ${params.row.BOOKING_ORDER_NO}`}
        >
          Print Options
        </button>
      ),
    },
  ];

  const loadVocherAPI = (invNo) => {
    const data = {
      table_prefix: prefix,
      FDATE: firstDate,
      TDATE: SecondDate,
      //   MOBILE: bookingCustomerDetails.mobile,
    };

    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/reportRoute/orderSummary`, data)
      .then(async function (response) {
        if (!response.data.error) {
          const data = response.data.response;
          const list = data.map((o, i) => {
            return {
              ...o,
              id: i,
            };
          });
          setList(list);
          setFullList(list);
        }
      })
      .catch(function (error) {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };
  const masterPrefix = useSelector(selectTableMasterPrefix);
  const getOrderDetails = (id, isQrCode, isDatagrid, isMeasSlip) => {
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/booking/loadCustomerOrder`, {
      table_prefix: prefix,
      BOOKING_ORDER_NO: id,
    })
      .then(async function (response) {
        if (!response.data.error) {
          const orderData = response.data.response;
          if (isMeasSlip) {
            ['UPPER', 'LOWER'].map(async (o) => {
              if (o === 'UPPER') {
                let upperList = [];
                await getEmptyMeasurementList(
                  'UPPER',
                  masterPrefix,
                  token
                ).then((e) => {
                  e.map((o) => {
                    const upperData = orderData.filter(
                      (data) =>
                        data.UPPER_LOWER === 'UPPER' &&
                        data.PARAMETER === o.PARAMETER
                    );
                    if (upperData[0]) {
                      setBookingDetails((e) => {
                        return {
                          ...e,
                          bookingOrderNumber: id,
                          upperTryDate: upperData[0].TRY_DATE,
                          upperDeliveryDate: upperData[0].DEL_DATE,
                          remarks: {
                            ...e.remarks,
                            upper: upperData[0].REMARKS,
                          },
                          date: moment(upperData[0].DATE).format('YYYY-MM-DD'),
                          selectedUpperItemDetails: {
                            item_name: upperData[0].ITEM_NAME,
                            regional_iname: upperData[0].REGIONAL_INAME,
                          },
                          mobile: upperData[0].MOBILE,
                          customer_name: upperData[0].CUSTOMER_NAME,
                        };
                      });
                      upperList.push({
                        ...upperData[0],
                        size: upperData[0].SIZE,
                      });
                    } else {
                      upperList.push(o);
                    }
                  });
                });
                const isNotEmpty = upperList.filter((o) => o.size !== '');
                if (isNotEmpty[0]) {
                  setUpperList(upperList);
                } else {
                  setUpperList([]);
                }
              } else {
                let lowerList = [];
                await getEmptyMeasurementList(
                  'LOWER',
                  masterPrefix,
                  token
                ).then((e) => {
                  e.map((o) => {
                    const lowerData = orderData.filter(
                      (data) =>
                        data.UPPER_LOWER === 'LOWER' &&
                        data.PARAMETER === o.PARAMETER
                    );
                    if (lowerData[0]) {
                      setBookingDetails((e) => {
                        return {
                          ...e,
                          bookingOrderNumber: id,
                          upperTryDate: lowerData[0].TRY_DATE,
                          upperDeliveryDate: lowerData[0].DEL_DATE,
                          remarks: {
                            ...e.remarks,
                            upper: lowerData[0].REMARKS,
                          },
                          date: moment(lowerData[0].DATE).format('YYYY-MM-DD'),
                          selectedLowerItemDetails: {
                            item_name: lowerData[0].ITEM_NAME,
                            regional_iname: lowerData[0].REGIONAL_INAME,
                          },
                          mobile: lowerData[0].MOBILE,
                          customer_name: lowerData[0].CUSTOMER_NAME,
                        };
                      });
                      lowerList.push({
                        ...lowerData[0],
                        size: lowerData[0].SIZE,
                      });
                    } else {
                      lowerList.push(o);
                    }
                  });
                });
                const isNotEmpty = lowerList.filter((o) => o.size !== '');
                if (isNotEmpty[0]) {
                  setLowerList(lowerList);
                } else {
                  setLowerList([]);
                }
                dispatch(setSpinnerLoading('Creating..'));
                handleSlipPRint();
              }
            });
          } else {
            if (isQrCode && !isDatagrid) {
              const upperQr = orderData.filter(
                (o) => o.UPPER_LOWER === 'UPPER'
              );
              const lowerQr = orderData.filter(
                (o) => o.UPPER_LOWER === 'LOWER'
              );
              setLowerListQR(lowerQr);
              setUpperListQR(upperQr);
            } else {
              if (isDatagrid) {
                const upperQr = orderData.filter(
                  (o) => o.UPPER_LOWER === 'UPPER'
                );
                const lowerQr = orderData.filter(
                  (o) => o.UPPER_LOWER === 'LOWER'
                );
                if (upperQr[0]) {
                  setIsQrType('UPPER');
                } else {
                  if (lowerQr[0]) {
                    setIsQrType('LOWER');
                  }
                }
                setIsUpper(upperQr);
                setIsLower(lowerQr);
                setAlertTwoButtonModal({
                  title: 'Print',
                  msg: `Do you want to print Measurements/QR Code`,
                  status: true,
                  setStatus: '',
                  button1: 'Measurements',
                  cancelAble: true,
                  button1Click: () => {
                    setAlertTwoButtonModal((e) => {
                      return {
                        ...e,
                        status: false,
                      };
                    });
                    getOrderDetails(id, false, false, true);
                  },
                  button2: 'Qr-code',
                  button2Click: () => {
                    setAlertTwoButtonModal((e) => {
                      return {
                        ...e,
                        status: false,
                      };
                    });
                    getOrderDetails(id, true);
                  },
                });
              }
            }
          }

          // now map the order details because may be one history have two type records like upper and lowwer
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'Error 109',
              msg: 'Something went wrong while loading customer order details',
            })
          );
        }
      })
      .catch(function (error) {
        dispatch(setSpinnerLoading(false));

        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };
  const navigate = useNavigate();

  const printRef = useRef();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState('print');
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize <= 800;
  const uniqueCustomers = new Set(
    list.map((row) => row.MOBILE || row.CUSTOMER_NAME).filter(Boolean)
  ).size;
  const uniqueCities = new Set(list.map((row) => row.CITY).filter(Boolean)).size;
  const uniqueCountries = new Set(
    list.map((row) => row.COUNTRY).filter(Boolean)
  ).size;
  const tableHeight = Math.min(460, Math.max(180, 112 + list.length * 42));

  const handlePrint = useReactToPrint({
    content: () =>
      selectedPrintOption === 'print'
        ? printRef.current
        : thermalPrintRef.current,
    pageStyle: `
      @page { size: A4 landscape; margin: 10mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
  });
  const handleSlipPrint = useReactToPrint({
    content: () => slipRef.current,
    onBeforeGetContent: () => {
      const style = document.createElement('style');
      style.innerHTML = `
        @page {
          size: portrait;
          margin: 0;
        }
      
      `;
      document.head.appendChild(style);

      return () => document.head.removeChild(style);
    },
  });
  const handleSlipPRint = () => {
    setTimeout(() => {
      dispatch(setSpinnerLoading(false));
      handleSlipPrint();
    }, 1000); // 1000 milliseconds = 1 second
  };

  const handleBarCodeScanner = useReactToPrint({
    content: () => QrprintRef.current,
    documentTitle: 'QR Code Print',
    onBeforeGetContent: () => {
      const style = document.createElement('style');
      style.innerHTML = `
        @page {
       size: 138px 460px;
              margin: 0
        }
        #print-qr * {
          visibility: visible;
          width: 132px;
          font-size: 15px;
        }
      `;
      document.head.appendChild(style);

      return () => document.head.removeChild(style);
    },
  });
  useEffect(() => {
    if (upperListQR[0] || lowerListQR[0]) {
      handleBarCodeScanner();
    }
  }, [upperListQR, lowerListQR]);

  const summaryCards = [
    {
      label: 'Total Orders',
      value: list.length,
      detail: list.length === 1 ? '1 order found' : `${list.length} orders found`,
      icon: 'bi-receipt',
      tone: 'text-[#f08a4b]',
      iconBg: 'bg-[#fff2e8]',
    },
    {
      label: 'Customers',
      value: uniqueCustomers,
      detail: 'Unique customers',
      icon: 'bi-people',
      tone: 'text-[#f5874f]',
      iconBg: 'bg-[#fff0e7]',
    },
    {
      label: 'Cities',
      value: uniqueCities,
      detail: 'Delivery cities',
      icon: 'bi-building',
      tone: 'text-[#8dbb28]',
      iconBg: 'bg-[#f1f8df]',
    },
    {
      label: 'Countries',
      value: uniqueCountries,
      detail: 'Customer countries',
      icon: 'bi-globe2',
      tone: 'text-[#a6405c]',
      iconBg: 'bg-[#fbe8ed]',
    },
  ];
  return (
    <div
      className={`flex h-full min-h-0 min-w-0 w-full flex-col overflow-x-hidden bg-[#fff9f6] p-3 ${
        isMobile ? 'overflow-y-auto' : 'overflow-y-hidden'
      }`}
    >
      <div className="mb-3 grid shrink-0 grid-cols-2 gap-3 xl:grid-cols-4">
        {summaryCards.map((card) => (
          <div
            key={card.label}
            className="flex min-w-0 items-center rounded-md border border-[#eadbd4] bg-white px-4 py-3 shadow-[0_2px_8px_rgba(31,45,61,0.04)]"
          >
            <div
              className={`mr-3 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${card.iconBg} ${card.tone}`}
            >
              <i className={`bi ${card.icon}`}></i>
            </div>
            <div className="min-w-0">
              <div className="truncate text-xs font-medium text-[#6b6260]">
                {card.label}
              </div>
              <div className={`truncate text-lg font-bold ${card.tone}`}>
                {card.value}
              </div>
              <div className="truncate text-[11px] text-[#8b7f7a]">
                {card.detail}
              </div>
            </div>
          </div>
        ))}
      </div>

      {isMobile ? (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDateMobile
            hideCustomer={true}
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-[30px] items-center justify-center gap-2 rounded-md border border-[#f5874f] px-4 text-sm font-semibold text-[#f5874f] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              dispatch(
                setBookingCustomerDetails({
                  customer_name: '',
                  mobile: '',
                })
              );
            }}
            bookingCustomerDetails={bookingCustomerDetails}
          />
        </div>
      ) : (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDate
            hideCustomer={true}
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-[#f5874f] px-5 text-sm font-semibold text-[#f5874f] transition hover:bg-[#fff2eb] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            reset={() => {
              dispatch(
                setBookingCustomerDetails({
                  customer_name: '',
                  mobile: '',
                })
              );
            }}
            bookingCustomerDetails={bookingCustomerDetails}
            reportLayout
          />
        </div>
      )}

      <FilterData
        placeHolder={'Search by order number'}
        placeHolder2={'Search by MRC number'}
        onFilter={(filterText) => {
          setList(
            FullList.filter((o) =>
              o.BOOKING_ORDER_NO.toString().includes(filterText)
            )
          );
        }}
        onFilter2={(filterText) => {
          setList(
            FullList.filter((o) => o.MRC_NO.toString().includes(filterText))
          );
        }}
      />

      <div
        className={`mt-3 flex min-h-0 min-w-0 flex-col max-sm:mt-2 ${
          isMobile ? 'shrink-0' : 'flex-1'
        }`}
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: tableHeight } : undefined}
          >
          <DataGrid
            sx={{
              height: '100%',
              width: '100%',
              minWidth: 0,
              borderRadius: '6px',
              backgroundColor: 'white',
              border: '1px solid #eadbd4',
              fontSize: 14,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8e4dc',
                color: '#383535',
                borderBottom: '2px solid #f5874f',
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#f8e4dc',
                borderRight: '1px solid #eadbd4',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 700,
                fontSize: '12px',
                letterSpacing: '0.025em',
                overflow: 'visible',
                textOverflow: 'clip',
              },
              '& .super-app-theme--header': {
                backgroundColor: '#f8e4dc',
              },
              '& .MuiDataGrid-cell': {
                borderRight: '1px solid #f0e3dd',
                borderBottom: '1px solid #f5ebe6',
                color: '#4b4545',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#fff2eb',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#fffaf7',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: '1px solid #eadbd4',
                color: '#6b6260',
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowX: 'auto',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
              },
            }}
            rowHeight={42}
            headerHeight={46}
            columns={columns}
            rows={list}
            pagination
            scrollbarSize={8}
            getRowId={(e) => e.id}
            rowsPerPageOptions={[100]}
            experimentalFeatures={{ newEditingApi: true }}
            showCellRightBorder={true}
            showColumnRightBorder={true}
            disableColumnSelector
            disableColumnReorder
            disableColumnMenu={true}
            components={{
              NoRowsOverlay: () => (
                <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                  <i className="bi bi-receipt mb-2 text-2xl opacity-60"></i>
                  <span className="font-medium">No orders found</span>
                  <span className="mt-1 text-xs">
                    Change the date range or search filters.
                  </span>
                </div>
              ),
            }}
          />
          </div>
          <div className="mt-2 flex min-h-[48px] shrink-0 items-center justify-between rounded-md border border-[#eadbd4] bg-white px-4 text-sm text-[#6b6260]">
            <span>Showing {list.length} of {FullList.length} orders</span>
            <span className="font-semibold text-[#514946]">
              Use Print Options for measurements or QR codes
            </span>
          </div>
        </div>
      </div>
      <CustomerMasterhelp
        onRowClick={(params) => {
          if (customerMasterModalStatus) {
            customerDetails(params);
          }
          dispatch(setCustomerMasterHelpModStatus(false));
        }}
      />
      <div className="hidden print:flex">
        <MeasurmentSlip
          ref={slipRef}
          upperData={upperList}
          date={bookingDetails.date}
          lowerData={lowerList}
          bookingOrderNumber={bookingDetails.bookingOrderNumber}
          upperTryDate={bookingDetails.upperTryDate}
          upperDeliveryDate={bookingDetails.upperDeliveryDate}
          lowerTryDate={bookingDetails.lowerTryDate}
          lowerDeleveryDate={bookingDetails.lowerDeleveryDate}
          lowerRemarks={bookingDetails.remarks.lower}
          upperRemarks={bookingDetails.remarks.upper}
          bookingCustomerDetails={bookingCustomerDetails}
          selectedUpperItemDetails={bookingDetails.selectedUpperItemDetails}
          selectedLowerItemDetails={bookingDetails.selectedLowerItemDetails}
          mobile={bookingDetails.mobile}
          customer_name={bookingDetails.customer_name}
        />
      </div>
      <div>
        <div className="hidden">
          {selectedPrintOption === 'print' && windowSize ? (
            <div
              ref={printRef}
              style={{ display: 'block', visibility: 'hidden' }}
            >
              <PrintOrderSummary
                data={list}
                firstDate={firstDate}
                SecondDate={SecondDate}
              />
            </div>
          ) : null}
        </div>
      </div>

      <div className="  print:flex">
        <OrderWiseQrCode ref={QrprintRef} list={selectedQrList} />
      </div>
      <AlertModalTwoButton
        ExtraFeature={
          <div className="text-sm flex justify-center mt-1 w-full">
            <div className="w-fit mt-3">
              <div className="flex justify-center mb-2">
                <div className="bg-gray-100 flex px-1 items-center rounded-sm">
                  <div className="bg-gray-100 pl-1">
                    <i className="bi bi-search text-sm flex items-center"></i>
                  </div>
                  <input
                    value={filterQrSearchTExt}
                    type="text"
                    autoFocus={true}
                    onChange={(e) => {
                      setFlterQrSearchText(e.target.value);
                    }}
                    placeholder="Search QR Code"
                    className="bg-transparent ml-2 py-1 w-[110px] outline-none"
                  />
                </div>

                <button
                  onClick={() => {
                    setFlterQrSearchText('upper');
                  }}
                  className="bg-gray-100 py-1 px-3 ml-2 rounded-sm"
                >
                  Upper
                </button>
                <button
                  onClick={() => {
                    setFlterQrSearchText('lower');
                  }}
                  className="bg-gray-100 py-1 px-3 ml-2 rounded-sm"
                >
                  Lower
                </button>
              </div>
              {isUpper[0] && (
                <div className=" mt-1 grid grid-cols-2 t:grid-cols-3 gap-2 min-w-[353px] t:min-w-[517px]">
                  {[...Array(isUpper[0].QNTY)].map((o, i) => {
                    const index = i + 1;
                    const value = `${isUpper[0].BOOKING_ORDER_NO}_UPPER_${isUpper[0].ICODE}_${index}`;
                    if (
                      filterQrSearchTExt &&
                      value
                        .toLowerCase()
                        .includes(filterQrSearchTExt.toLowerCase())
                    ) {
                      return qrOption(value, setSelectedQrList, isUpper[0]);
                    } else {
                      if (!filterQrSearchTExt) {
                        return qrOption(value, setSelectedQrList, isUpper[0]);
                      }
                    }
                  })}
                </div>
              )}

              {isLower[0] && (
                <div className=" mt-1 grid grid-cols-2 t:grid-cols-3 gap-2">
                  {[...Array(isLower[0].QNTY)].map((o, i) => {
                    const index = i + 1;
                    const value = `${isLower[0].BOOKING_ORDER_NO}_LOWER_${isLower[0].ICODE}_${index}`;
                    if (
                      filterQrSearchTExt &&
                      value
                        .toLowerCase()
                        .includes(filterQrSearchTExt.toLowerCase())
                    ) {
                      return lowerQrOption(
                        value,
                        setSelectedQrList,
                        isLower[0]
                      );
                    } else {
                      if (!filterQrSearchTExt) {
                        return lowerQrOption(
                          value,
                          setSelectedQrList,
                          isLower[0]
                        );
                      }
                    }
                  })}
                </div>
              )}
              <div className="mt-2 px-2">
                <div className="flex pb-1 font-semibold ">Selected QR Code</div>
                <div className="h-[150px] overflow-y-auto">
                  {selectedQrList.map((qr) => {
                    return (
                      <div className="flex justify-between my-1">
                        <div>{qr.qrCode}</div>
                        <div className="flex">
                          <div className="w-[40px]">Qnty</div>:
                          <div className="ml-2 flex items-center border  justify-center">
                            <button
                              onClick={() => {
                                setSelectedQrList((q) =>
                                  q.map((o) => {
                                    if (o.qrCode === qr.qrCode) {
                                      const newQnty = o.qnty - 1;
                                      return {
                                        ...o,
                                        qnty: newQnty > 0 ? newQnty : 1,
                                      };
                                    } else {
                                      return o;
                                    }
                                  })
                                );
                              }}
                              className="flex items-center h-full px-1 border-r bg-gray-50"
                            >
                              <RemoveIcon
                                sx={{
                                  fontSize: '16px',
                                }}
                              />
                            </button>
                            <input
                              type="number"
                              value={qr.qnty}
                              className=" text-center rounded-sm outline-none text-red bg-transparent  w-[20px] "
                            />
                            <button
                              onClick={() => {
                                setSelectedQrList((q) =>
                                  q.map((o) => {
                                    if (o.qrCode === qr.qrCode) {
                                      return {
                                        ...o,
                                        qnty: o.qnty + 1,
                                      };
                                    } else {
                                      return o;
                                    }
                                  })
                                );
                              }}
                              className="flex items-center h-full px-1 border-l bg-gray-50"
                            >
                              <AddIcon
                                sx={{
                                  fontSize: '16px',
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        }
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
    </div>
  );
};

export default OrderSummary;
function lowerQrOption(value, setSelectedQrList, o) {
  return (
    <div
      className=" bg-slate-100 items-center flex p-2 rounded-sm"
      value={value}
    >
      {' '}
      <input
        type="checkbox"
        className=" mr-2"
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedQrList((u) => {
              return [
                ...u,
                {
                  ...o,
                  qrCode: value,
                  qnty: 1,
                },
              ];
            });
          } else {
            setSelectedQrList((u) => u.filter((q) => q.qrCode !== value));
          }
        }}
      />
      👖
      {value}
    </div>
  );
}

function qrOption(value, setSelectedQrList, o) {
  return (
    <div
      className=" bg-slate-100 items-center flex p-2 rounded-sm"
      value={value}
    >
      {' '}
      <input
        type="checkbox"
        className=" mr-2"
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedQrList((q) => {
              return [
                ...q,
                {
                  ...o,
                  qrCode: value,
                  qnty: 1,
                },
              ];
            });
          } else {
            setSelectedQrList((q) => q.filter((q) => q.qrCode !== value));
          }
        }}
      />
      👕
      {value}
    </div>
  );
}
